import React from 'react';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-amber-100 text-amber-600 px-4 py-2 rounded-full text-sm font-semibold border border-amber-200">Student Success</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">Success <span className="text-blue-600">Stories</span></h2>
          <p className="text-xl text-gray-600">Hear from our OSSD graduates</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="bg-white border-2 border-amber-200 rounded-2xl p-8 hover:shadow-xl transition-shadow hover:border-amber-400">
            <div className="flex items-center space-x-1 mb-4">
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
            </div>
            <p className="text-gray-700 mb-6 italic">"EduNexa's OSSD program transformed my academic journey. The structured curriculum and support helped me secure admission to University of Toronto!"</p>
            <div>
              <p className="font-bold text-gray-900">Charu Sharma</p>
              <p className="text-sm text-gray-600">University of Toronto</p>
              <p className="text-sm text-amber-600 font-semibold">Computer Science</p>
            </div>
          </div>

          <div className="bg-white border-2 border-amber-200 rounded-2xl p-8 hover:shadow-xl transition-shadow hover:border-amber-400">
            <div className="flex items-center space-x-1 mb-4">
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
            </div>
            <p className="text-gray-700 mb-6 italic">"The faculty's guidance was invaluable. OSSD gave me the competitive edge I needed for UBC. Best decision I ever made!"</p>
            <div>
              <p className="font-bold text-gray-900">Jimmy Lau</p>
              <p className="text-sm text-gray-600">University of British Columbia</p>
              <p className="text-sm text-amber-600 font-semibold">Business Administration</p>
            </div>
          </div>

          <div className="bg-white border-2 border-amber-200 rounded-2xl p-8 hover:shadow-xl transition-shadow hover:border-amber-400">
            <div className="flex items-center space-x-1 mb-4">
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
              <span className="text-amber-500 text-2xl">★</span>
            </div>
            <p className="text-gray-700 mb-6 italic">"From application to admission, EduNexa supported me every step. Now I'm studying at McGill - my dream came true!"</p>
            <div>
              <p className="font-bold text-gray-900">Chinedu Okafor</p>
              <p className="text-sm text-gray-600">McGill University</p>
              <p className="text-sm text-amber-600 font-semibold">Biological Sciences</p>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-6 text-white shadow-lg">
            <p className="text-4xl font-bold mb-2">98%</p>
            <p className="text-blue-100">Student Satisfaction</p>
          </div>
          <div className="bg-gradient-to-br from-amber-400 to-amber-500 rounded-2xl p-6 text-white shadow-lg">
            <p className="text-4xl font-bold mb-2">95%</p>
            <p className="text-amber-100">University Acceptance</p>
          </div>
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-6 text-white shadow-lg">
            <p className="text-4xl font-bold mb-2">1000+</p>
            <p className="text-blue-100">Students Placed</p>
          </div>
        </div>
      </div>
    </section>
  );
};
